import { useEffect } from 'react'

import { countryToLanguagesMap } from 'consts/countryToLanguageMap'

import { setBaseURL } from 'services/axios'
import { backendApiUrl } from 'services/config'

import i18n, { changeLanguage } from 'services/i18n'
import { Country } from 'types/Api'

import { useCountry } from './useCountry'
import { useFavicon } from './useFavicon'
import { usePWAManifest } from './usePWAManifest'
import { usePreferredLanguage } from './usePreferredLanguage'
import { useTitle } from './useTitle'

type Input = {
  country?: Country
}

export const useCountrySetup = ({ country }: Input) => {
  const { createFavicon } = useFavicon()
  const { createPWAManifest } = usePWAManifest()
  const { updateTitle } = useTitle()

  const countryFromConfig = useCountry()

  const { preferredLanguage } = usePreferredLanguage()

  useEffect(() => {
    document.documentElement.lang = i18n.language

    const countryLanguage = country
      ? countryToLanguagesMap[country][0]
      : countryToLanguagesMap[countryFromConfig][0]

    const appliedLanguage = preferredLanguage || countryLanguage

    changeLanguage(appliedLanguage)
  }, [country, countryFromConfig, preferredLanguage])

  useEffect(() => {
    if (country) {
      setBaseURL(`${backendApiUrl}/${country}`)
      createFavicon()
      createPWAManifest()
      updateTitle()
    }
  }, [country, createFavicon, createPWAManifest, updateTitle])
}
